import React, { createContext, useState } from "react";

const initialState = {
    casino: {},
};

export const FavoritesContext = createContext();

export const FavoritesContextProvider = ({ children }) => {
    const [state, setState] = useState(initialState);

    const changeFavorites = (key, list) => {
        setState({
            ...state,
            [key]: list,
        });
    };

    return <FavoritesContext.Provider value={[state, changeFavorites]}>
        {children}
    </FavoritesContext.Provider>
};